module.exports = __webpack_public_path__ + "static/lightning-datepicker-basic-389f617f39e46a615cc2622350b7500f.png";